import {create} from "zustand";

export const useProfileStore = create((set) => ({
    //
}));
